
export enum TableName {
  Storage = 'storage',
  SyncStatusItems = 'syncStatusItems',
  ServiceFacilities = 'serviceFacilities',
  Customers = 'customers',
  AudioRecords = 'audioRecords',
  SyncTimes = 'syncTimes',
  // -------------------------------------------------------------------------------------------------------------------
  // Wound documentation
  // -------------------------------------------------------------------------------------------------------------------
  WmWoundQuestions = 'wmWoundQuestions',
  WmWoundLocations = 'wmWoundLocations',
  WmWoundFinishedReasons = 'wmWoundFinishedReasons',
  WmWoundDocumentations = 'wmWoundDocumentations',
  WmWoundDocumentationEntries = 'wmWoundDocumentationEntries',
  WmWoundAnswers = 'wmWoundAnswers',
  WmWoundImages = 'wmWoundImages',
// ---------------------------------------------------------------------------------------------------------------------
  // Care
  // -------------------------------------------------------------------------------------------------------------------
  CdAimEvaluationReasons = 'cdAimEvaluationReasons',
  CdAimEvaluationScales = 'cdAimEvaluationScales',
  CdRais = 'cdRais',
  CdMdsAnswers = 'cdMdsAnswers',
  CdCarePlans = 'cdCarePlans',
  CdAimEvaluations = 'cdAimEvaluations',
  CdAddedAims = 'cdAddedAims',
  // -------------------------------------------------------------------------------------------------------------------
  // Time tracking
  // -------------------------------------------------------------------------------------------------------------------
  TtActivityEntries = 'ttActivityEntries',
  TtActivityTypes = 'ttActivityTypes',
  TtTravelEntries = 'ttTravelEntries',
  TtProductEntries = 'ttProductEntries',
  // -------------------------------------------------------------------------------------------------------------------
  // Operating plan
  // -------------------------------------------------------------------------------------------------------------------
  OpOperatingPlanItems = 'opOperatingPlanItems',
  // -------------------------------------------------------------------------------------------------------------------
  // Employee rosters
  // -------------------------------------------------------------------------------------------------------------------
  EmployeeRosters = 'employeeRosters',
  // -------------------------------------------------------------------------------------------------------------------
  // Product management
  // -------------------------------------------------------------------------------------------------------------------
  ProdRequests = 'prodRequests',
  // -------------------------------------------------------------------------------------------------------------------
  // Customer documents
  // -------------------------------------------------------------------------------------------------------------------
  CustomerDocuments = 'customerDocuments'
}
